export default __webpack_public_path__ + "static/media/img3pic3.934829b4.png";